import styled from "styled-components";
import { COLORS, BORDER_RADIUS, FONT_SIZE } from "../Variables";

export const VictoryBox = styled.div`
position: relative;
grid-column: 1/2;
grid-row: 1/2;
display: flex;
justify-content: center;
top: ${(props) => props.top ? props.top : "-10px"};
left: ${(props) => props.left ? props.left : "-10px"};
width: ${(props) => props.width ? props.width : "10%"};
height: 28px;
padding: 8px;
background-color: ${COLORS.red};
z-index: 2;
border-radius: ${(props) => props.radius ? props.radius : `${BORDER_RADIUS}`};
color: ${COLORS.white};
font-size: ${FONT_SIZE.smaller};
text-transform: uppercase;
letter-spacing: 1px;
font-weight: 900;
&::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 3px;
  border-color: transparent ${COLORS.darkRed} transparent transparent;
  border-style: solid;
  border-width: 0 8px 7px 0;
  display: ${(props) => props.display ? props.display : ""};
}
`;
export const VictoryText = styled.p`
grid-column: 1/-1;
grid-row: 2/3;
margin: 0 0 10px;
position: relative;
top: 45px;
border-bottom: 1px solid ${COLORS.greyColor};
font-size: ${FONT_SIZE.default};
font-weight: 600;
color: ${COLORS.black};
text-transform: capitalize;
`;

export const SignersIcon = styled.svg`
  width: 13px;
  path {
    fill: ${(props) => props.lang === 'hazteoir' ? `${COLORS.hoOrange}` : `${COLORS.cgoBlue}` };
  }
`;